import qs from 'query-string'

export default function subscribeToMailingList(id, fields) {
  return fetch(`https://api.convertkit.com/v3/forms/${id}/subscribe`, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: qs.stringify({
      api_key: '617ze_vOpzLKL9yB_BbsXQ',
      ...fields,
    }),
  })
  // ConvertKit sends back an identical response whether or not
  // the request was valid
}
